import { fetchToken } from "../../../common/FetchCookie"

export const fetchCandidateDetails = async (candidateId) => {
    try {
        // console.log("Fetching candidate details for UUID:", candidateId)
        const token = await fetchToken()

        if (!token) {
            console.error("Authentication token is missing")
            throw new Error("Authentication token is missing")
        }

        // console.log("Token retrieved successfully")

        // Build the URL with all required parameters
        const url = `https://api.indiahirings.com/employer/candidate-show-profile/${candidateId}?basic_details=1&employment=1&projects=1&skills=1&job_preference=1&education=1&certifications=1&it_skills=1&current_company=1&candidate_languages=1`
        // console.log("Request URL:", url)

        const response = await fetch(url, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })

        // console.log("API Response status:", response.status)

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}))
            console.error("Error response:", errorData)
            const error = new Error(`Request failed with status ${response.status}`)
            error.response = {
                status: response.status,
                data: errorData
            }
            throw error
        }

        const data = await response.json()
        // console.log("API Response data structure:", Object.keys(data))

        // Log the first level of the response to better understand structure
        if (data.response && data.response.data) {
            // console.log("Data found at data.response.data")
            return data.response.data // Return the actual data
        } else if (data.data) {
            // console.log("Data found at data.data")
            return data.data // Return the actual data
        } else {
            // console.log("Data at root level")
            return data // Return the entire response
        }
    } catch (error) {
        console.error("Show-Candidate API error:", error)
        // Ensure the error has all the details we want to display
        if (!error.response) {
            error.response = {
                data: { message: error.message }
            }
        }
        throw error
    }
}
